import pro1 from '../assets/travel.png';
import pro2 from '../assets/notes.jpeg';
import pro3 from '../assets/agecare.jpeg';

const ProjectData =[
          {
              imgsrc : pro1,
              title:"Travel Jorunal",
              text:"A Travel Journal where in all the travel destination visited my me including the places such as Golden Temple etc..,The project was built with the help of Reactjs which is a Javascript library for frontend application the main motive of the project was created by using props functionality so the data can be easily reused and scaleable.",  
              view:"https://github.com/yadav-siddharth/Travel-Journal",
              source:"https://github.com/yadav-siddharth/Travel-Journal",
          },

          {
                    imgsrc : pro2,
                    title:"Notes App",
                    text:"The Notes application is the one of the most daily useage application ,so creating an AI that can create notes through speech , check the sentiment of the notes , check for grammar all this will implemented by using ML alogrithms through Natural Language Processing Team Members : Siddharth Yadav , Abhishek Shrike , Aadi Vora , Sandeep Sinha",  
                    view:"https://github.com/yadav-siddharth/Notes-App",
                    source:"https://github.com/yadav-siddharth/Notes-App",
          },

          {
                    imgsrc : pro3,
                    title:"Age Care",
                    text:"In most of the metro-politian cities many of the elderly people have to stay alone in the home , So to create a platform were professional and verfied nurses to provided at a certain time slot fro daily household chores. The project was developed with backend knowledge of Nodejs and for frontend ejs was used and for database Mongo-DB      Team Members : Siddharth Yadav , Abhishek Shrike , Aadi Vora",  
                    view:"https://github.com/yadav-siddharth/Age_Care",
                    source:"https://github.com/yadav-siddharth/Age_Care",
          }
]

export default ProjectData;